import { Directive, ElementRef, OnDestroy, OnInit } from "@angular/core";
import { handleRichTextSpecialLinkClick } from "../utils/rich-text-content.util";

@Directive({
  selector: ".rich-text-content",
})
export class RichTextContentLinkDirective implements OnInit, OnDestroy {
  private readonly onClick = (event: MouseEvent) => {
    handleRichTextSpecialLinkClick(event);
  };

  private readonly onKeydown = (event: KeyboardEvent) => {
    handleRichTextSpecialLinkClick(event);
  };

  constructor(private elementRef: ElementRef<HTMLElement>) {}

  ngOnInit(): void {
    const element = this.elementRef.nativeElement;
    element.addEventListener("click", this.onClick, true);
    element.addEventListener("keydown", this.onKeydown, true);
  }

  ngOnDestroy(): void {
    const element = this.elementRef.nativeElement;
    element.removeEventListener("click", this.onClick, true);
    element.removeEventListener("keydown", this.onKeydown, true);
  }
}
